import request from '../request'
import apis from '../apis'

export default {

    /**
     * 查询资源开关配置
     */
    getResourceSwitchSer(param) {
        return request.get(`${apis.GET_RESOURCE_SWITCH}`, { params: param });
    },

    /**
     * 编辑资源开关配置
     */
    updateResourceSwitchSer(params) {
        return request.post(`${apis.UPDATA_RESOURCE_SWITCH}`, params)
    },

    /**
     * 获取资源模块是否存在订单
     */
    getOrderExistsSer(param) {
        return request.get(`${apis.GET_ORDER_EXISTS}`, { params: param });
    },

    /**
     * 查询流程开关配置
     */
    getProcessSwitchSer(param) {
        return request.get(`${apis.GET_PROCESS_SWITCH}`, { params: param });
    },

    /**
     * 查询审批流程列表
     */
    getProcessListSer(param) {
        return request.get(`${apis.GET_PROCESS_LIST}`, { params: param });
    },

    /**
     * 保存流程
     */
    saveProcessSer(param) {
        return request.get(`${apis.SAVE_PROCESS}`, { params: param });
    },

    /**
     * 修改流程开关
     */
    updateProcessSwitchSer(params) {
        return request.post(`${apis.UPDATE_PROCESS_SWITCH}`, params)
    },

    /**
     * 查询流程开关修改日志
     */
    getProcessSwitchHistorySer(param) {
        return request.get(`${apis.GET_PROCESS_SWITCH_HISTORY}`, { params: param });
    }
}
